import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/Bits";
import { BookOpen, HeartHandshake, Landmark, Target } from "lucide-react";

export default function About() {
  const [about, setAbout] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setAbout((r.data || {}).about || {})); }, []);

  const blocks = [
    { icon: Landmark, title: "Our History", text: about.history },
    { icon: BookOpen, title: "Facilities & E-Services", text: about.facilities },
    { icon: Target, title: "Objects & Governance", text: about.mission },
    { icon: HeartHandshake, title: "Leadership & Legacy", text: about.welfare },
  ].filter((b) => b.text && b.text.trim());

  return (
    <div data-testid="about-page">
      <PageHeader title="About the Association" subtitle="A historic institution of the legal fraternity at the Principal Seat of the High Court of Madhya Pradesh." />
      <section className="max-w-5xl mx-auto px-4 py-16 space-y-12">
        {blocks.map((b, i) => (
          <div key={i} className="grid md:grid-cols-[auto,1fr] gap-6 items-start fade-up" data-testid={`about-block-${i}`}>
            <div className="w-14 h-14 rounded-full bg-[#EAF1FB] border border-[#E6C687] flex items-center justify-center text-[#123B7A]">
              <b.icon size={24} />
            </div>
            <div>
              <h3 className="font-display text-2xl font-semibold text-[#0B2E63] mb-2">{b.title}</h3>
              <div className="gold-rule w-16 mb-4" />
              <div className="space-y-4">
                {b.text.split("\n\n").map((para, j) => (
                  <p key={j} className="text-[#3a4250] leading-relaxed font-garamond text-lg">{para}</p>
                ))}
              </div>
            </div>
          </div>
        ))}
        {blocks.length === 0 && <p className="text-center text-[#5A6270]">Content will be updated shortly.</p>}
      </section>
    </div>
  );
}
